module.exports = __webpack_public_path__ + "img/icon_order.e31d4b79.svg";